import { BreadcrumbItem } from "@/types/breadcrumbs"
import { classNames } from "@/utils/classNames"
import { IconArrowRight } from "@tabler/icons-react"
import { Fragment } from "react"
import { Typography } from "../Typography/Typography"

interface BreadcrumbsNavigationProps {
  breadcrumbs: BreadcrumbItem[]
  className?: string
}

export const BreadcrumbsNavigation: React.FC<BreadcrumbsNavigationProps> = ({
  breadcrumbs,
  className = "",
}) => {
  const indexSelectedPage = breadcrumbs.findIndex((item) => item.isSelected)

  return (
    <nav aria-label="breadcrumb" className={classNames(className)}>
      <ol className="m-0 flex list-none flex-wrap items-center p-0">
        {breadcrumbs.map((breadcrumb, index) => {
          const isDisabled = index > indexSelectedPage

          return (
            <Fragment key={breadcrumb.title}>
              {index > 0 && (
                <li aria-hidden="true" className="mx-2 flex select-none">
                  <IconArrowRight size={13} className="text-grey5" />
                </li>
              )}
              <li>
                <div
                  className={classNames(
                    "rounded-lg",
                    "cursor-default",
                    "px-S py-XS",
                    "text-white",
                    "bg-grey3",
                    breadcrumb.isSelected && "bg-grey4",
                  )}
                >
                  <Typography
                    variant="textXS"
                    className={classNames(
                      isDisabled && "text-grey4",
                      breadcrumb.isSelected && "text-yellow1",
                    )}
                  >
                    {breadcrumb.title}
                  </Typography>
                </div>
              </li>
            </Fragment>
          )
        })}
      </ol>
    </nav>
  )
}
